import React from "react";
import "../assets/css/contactHero.css";

const ContactHero = () => {
    return (
        <>
            <section className="about-container">
                <div className="about-header">
                    <span className="about-subtitle">ABOUT US</span>
                    <p className="about-details">
                        We are engaged in the manufacturing of different types of synthetic resins. We have complete facilities for 
                        manufacturing Phenol Formaldehyde Phenolic Resins, including Novolac (solid resin) and Resol 
                        (liquid phenolic resin), Urea Formaldehyde Resin, Melamine Formaldehyde Resin, and Melamine Urea Formaldehyde 
                        Resin. Our advanced manufacturing infrastructure is supported by complete in-house testing and quality
                        control facilities, enabling us to produce resins in strict accordance with ISI standards. Furthermore, 
                        we offer tailor-made resin solutions, developed precisely as per customer-specific formulations, performance 
                        criteria, and application needs.
                    </p>
                </div>

                <div className="about-content-wrapper">
                    <div className="about-image-card">
                        <img
                            src={require('../assets/images/about/about-us-featured-image.png')}
                            alt="Scientist working in a lab"
                            className="about-image"
                        />
                    </div>
                </div>
            </section>
        </>
    );
};

export default ContactHero;
